import { render } from "./RotaInicial.vue?vue&type=template&id=4f8d9ebd&scoped=true"
import script from "./RotaInicial.vue?vue&type=script&lang=js"
export * from "./RotaInicial.vue?vue&type=script&lang=js"

import "./RotaInicial.vue?vue&type=style&index=0&id=4f8d9ebd&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8d9ebd"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon});
